<template>
  <div class="push-tenant-records">
    <ContentBlock>
      <TableWithPagination class="special" :columnList="columnList" :tableData="targetLists" :mergeCells="mergeCells" :toolBar="toolBar" :sortInfo.sync="sortInfo" tableBorder="default" :showRightToolbar="true" :pagination.sync="pagination" @size-change="getTargetLists" @current-change="getTargetLists" @sort-change="getTargetLists" :highHoverRow="false" :highlightRow="false" />
    </ContentBlock>
    <el-drawer title="高级筛选" width="400" direction="rtl" :modal-append-to-body="false" :visible.sync="isShow"
      :close-on-click-modal="false" @closed="isShow = false">
      <el-form label-width="auto" label-position="right" style="margin-top: 20px;padding: 10px;">
        <el-row>
          <el-col :span='24'>
            <el-form-item label="用户名称">
              <el-input placeholder="请输入用户名称" v-model.trim="form.tenantName" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="企业编号">
              <el-input placeholder="请输入企业编号" v-model.trim="form.tenantCode" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="历史累计推送数据">
              <div class="flex">
                <el-select v-model.trim="form.totalCountComparisonOperator" placeholder="请选择" clearable :popper-append-to-body="false" style="width: 200px;">
                  <el-option v-for="item in rangeOptions" :key="'total-'+item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-input-number placeholder="请输入" v-model.trim="form.totalCount" step-strictly :controls="false" :min="0" style="width: 100%;"></el-input-number>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="推送成功条数">
              <div class="flex">
                <el-select v-model.trim="form.successCountComparisonOperator" placeholder="请选择" clearable :popper-append-to-body="false" style="width: 200px;">
                  <el-option v-for="item in rangeOptions" :key="'succ-'+item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-input-number placeholder="请输入" v-model.trim="form.successCount" step-strictly :controls="false" :min="0" style="width: 100%;"></el-input-number>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="推送失败条数">
              <div class="flex">
                <el-select v-model.trim="form.failureCountComparisonOperator" placeholder="请选择" clearable :popper-append-to-body="false" style="width: 200px;">
                  <el-option v-for="item in rangeOptions" :key="'fail-'+item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-input-number placeholder="请输入" v-model.trim="form.failureCount" step-strictly :controls="false" :min="0" style="width: 100%;"></el-input-number>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: center;">
        <el-button @click="handleEmpty">清空</el-button>
        <el-button type="primary" @click="handleQuery">查询</el-button>
      </div>
    </el-drawer>

    <!-- 商机明细弹窗 -->
    <DetailDialog v-if="detailDialogVisible" :dialog-visible.sync="detailDialogVisible" :tenantId="currentOpportunity.tenantId"></DetailDialog>
  </div>
</template>
<script>
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import { getTenantSendRecordStatisticPageList } from '@/api/niche';
import icRefresh from '@/assets/table/ic_refresh.svg';
import icAdvanceSearch from '@/assets/table/ic_advanceSearch.svg';
import DetailDialog from '../components/detailDialog';

const rangeOptions = [
  {
    label: '大于',
    value: 1,
  },
  {
    label: '小于',
    value: 2,
  },
  {
    label: '等于',
    value: 3,
  },
  {
    label: '大于等于',
    value: 4,
  },
  {
    label: '小于等于',
    value: 5,
  },
];

export default {
  name: 'SASS_GXTGL_BUSINESSOPPORTUNITY',
  components: {
    TableWithPagination,
    DetailDialog,
  },
  mixins: [TablePaginationMixin],
  computed: {
    toolBar () {
      let currentLists = [
        {
          type: 'custom',
          render: () => {
            return (
              <el-input placeholder='请输入用户名称' style='width:250px;' v-model={this.form.tenantName}>
                <el-button slot="suffix" icon="el-icon-search" onClick={this.handleSearch} style='position: absolute;height: 100%;right: -5px;top: 0;'>
                </el-button>
              </el-input>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            return (
              <vxe-button circle onClick={this.handleAdvancedSearch}>
                <img style='font-size:14px;width:15px;height:15px;' src={icAdvanceSearch} />
              </vxe-button>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            return (
              <vxe-button circle onClick={this.handleReset}>
                <img style='font-size:14px;width:15px;height:15px;' src={icRefresh} />
              </vxe-button>
            );
          },
        },
      ];
      return currentLists;
    },
    columnList () {
      const cols = [
        {
          tooltip: true,
          label: '用户名称',
          minWidth: '150px',
          width: '',
          key: 'tenantName',
          prop: 'tenantName',
        },
        {
          tooltip: true,
          label: '企业编号',
          minWidth: '100px',
          width: '',
          key: 'tenantCode',
          prop: 'tenantCode',
        },
        {
          tooltip: true,
          label: '历史累计推送条数',
          minWidth: '120px',
          width: '',
          key: 'totalCount',
          prop: 'totalCount',
          render: (h, { row }) => {
            return `${row.totalCount !== null ? `${row.totalCount}条` : '--'}`;
          },
        },
        {
          tooltip: true,
          label: '推送成功条数',
          minWidth: '120px',
          width: '',
          key: 'successCount',
          prop: 'successCount',
          render: (h, { row }) => {
            return `${row.successCount !== null ? `${row.successCount}条` : '--'}`;
          },
        },
        {
          tooltip: true,
          label: '推送失败条数',
          minWidth: '120px',
          width: '',
          key: 'failureCount',
          prop: 'failureCount',
          render: (h, { row }) => {
            return `${row.failureCount !== null ? `${row.failureCount}条` : '--'}`;
          },
        },
        {
          tooltip: true,
          label: '成功率',
          minWidth: '120px',
          width: '',
          key: 'successRate',
          prop: 'successRate',
        },
      ];

      cols.push({
        label: '操作',
        prop: 'action',
        width: '70px',
        fixed: 'right',
        render: (h, { row }) => {
          let actions = [];
          actions.push(h('span', {
            domProps: {
              className: 'table-action',
            },
            on: {
              click: () => { this.handleDetail(row); },
            },
          }, '查看'));
          return h('div', actions);
        },
      });

      return cols;
    },
  },
  data () {
    return {
      rangeOptions,
      form: {
        failureCount: null,
        failureCountComparisonOperator: null,
        successCount: null,
        successCountComparisonOperator: null,
        totalCount: null,
        totalCountComparisonOperator: null,
        tenantCode: '',
        tenantName: '',
      },
      sendTime: '',
      targetLists: [],
      mergeCells: [],
      isShow: false,
      isLoading: false,
      detailDialogVisible: false,
      currentOpportunity: {},
    };
  },
  methods: {
    handleDetail (v) {
      // 查看详情弹窗
      this.currentOpportunity = v;
      this.detailDialogVisible = true;
    },
    handleQuery () {
      this.pagination.currentPage = 1;

      this.getTargetLists();

      this.$nextTick(() => {
        this.isShow = false;
      });
    },
    handleSearch () {
      this.pagination.currentPage = 1;

      this.getTargetLists();
    },
    handleAdvancedSearch () {
      this.isShow = true;
    },
    handleReset () {
      this.handleEmpty();

      this.pagination.currentPage = 1;

      this.getTargetLists();
    },
    handleEmpty () {
      this.form = this.$options.data().form;
    },
    getTargetLists () {
      const params = {
        ...this.form,
        failureCount: this.form.failureCountComparisonOperator ? this.form.failureCount : null,
        successCount: this.form.successCountComparisonOperator ? this.form.successCount : null,
        totalCount: this.form.totalCountComparisonOperator ? this.form.totalCount : null,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };

      getTenantSendRecordStatisticPageList(params).then(({ body }) => {
        this.targetLists = body?.list || [];
        this.pagination.total = Number(body?.total || 0);
      });
    },
  },
  created () {
    this.handleSearch();
  },
};
</script>
<style scoped lang='scss'>
.push-tenant-records {
  .flex {
    display: flex;
    align-items: center;
  }
}
/deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #409EFF;
  border-color: #409EFF;
}

/deep/.vxe-tools--wrapper {
  display: flex;
  justify-content: space-between;

  &>.el-button {
    margin-left: 0.5em;
  }

  &>div.el-input {
    margin-left: 0.5em;
  }

  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .vxe-tools--operate {
  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .action {
  color: #409EFF;
  cursor: pointer;

  &:hover {
    color: rgba(64, 158, 255, 0.7);
    text-decoration: underline;
  }
}
</style>
